function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function removeName(v) {
  if (v && v.name) {
    // eslint-disable-next-line
    var name = v.name,
        rest = _objectWithoutProperties(v, ["name"]);

    return _objectSpread({}, rest);
  }

  return v;
}

function rollup(f) {
  var values = f.values.map(removeName).map(function (v) {
    return _defineProperty({}, f.field, v);
  });
  return _defineProperty({}, f.type || "any", values);
}

function adaptFilters(filters) {
  if (!filters || filters.length === 0) return {};
  var all = filters.map(rollup);
  return {
    all: all
  };
}

export function adaptRequest(request) {
  var current = request.current,
      resultsPerPage = request.resultsPerPage,
      searchTerm = request.searchTerm,
      sortDirection = request.sortDirection,
      sortField = request.sortField;
  var sort = sortField && sortDirection ? _defineProperty({}, sortField, sortDirection) : undefined;
  return _objectSpread({
    query: searchTerm
  }, sort !== undefined && {
    sort: sort
  }, {
    page: _objectSpread({}, resultsPerPage !== undefined && {
      size: resultsPerPage
    }, current !== undefined && {
      current: current
    }),
    filters: adaptFilters(request.filters)
  });
}